import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, IconButton, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ReasonModal = ({ open, label, subReasons, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "16px",
            width: { xs: "98%", sm: "512px" },
            maxWidth: "100%",
            p: { xs: 1.5, sm: 3 },
            m: 1,
            backgroundColor: "#F7F8FB",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: { xs: "18px", sm: "20px" },
            color: "#111",
            flex: 1,
            minWidth: 0,
          }}
        >
          {label} - Reasons
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "#000" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          border: "1.5px solid #F7F8FB",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            bgcolor: "#CFCEDA",
            p: "14px 20px",
            borderBottom: "1.5px solid #FFFFFF",
          }}
        >
          <Typography
            sx={{
              flex: 1,
              fontWeight: 600,
              fontSize: "14px",
              color: "#403C6F",
            }}
          >
            Reason
          </Typography>
          <Box
            sx={{
              width: "1.5px",
              bgcolor: "#CFCEDA",
              mx: 0,
              my: -2,
              border: "1px solid #F7F8FB",
            }}
          />
          <Typography
            sx={{
              width: "80px",
              textAlign: "center",
              fontWeight: 600,
              fontSize: "14px",
              color: "#403C6F",
            }}
          >
            Count
          </Typography>
        </Box>

        <Box
          sx={{
            maxHeight: "400px",
            overflowY: "auto",
            "&::-webkit-scrollbar": { display: "none" },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          {(subReasons && subReasons.length > 0 ? subReasons : []).map(
            (item, i, arr) => (
              <Box
                key={item.label}
                sx={{
                  display: "flex",
                  alignItems: "stretch",
                  backgroundColor: "#FFFFFF",
                  borderBottom:
                    i === arr.length - 1 ? "none" : "1.5px solid #F7F8FB",
                  "&:hover": { bgcolor: "#FBFAFF" },
                }}
              >
                <Typography
                  sx={{
                    flex: 1,
                    fontSize: "14px",
                    color: "#333",
                    p: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {item.label || "Unknown Reason"}
                </Typography>
                <Box
                  sx={{
                    width: "2px",
                    bgcolor: "#F7F8FB",
                    alignSelf: "stretch",
                    mx: 0,
                  }}
                />
                <Typography
                  sx={{
                    width: { xs: "60px", sm: "100px" },
                    textAlign: "center",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#333",
                    p: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {item.count ?? 0}
                </Typography>
              </Box>
            ),
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

ReasonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  label: PropTypes.string,
  subReasons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  onClose: PropTypes.func.isRequired,
};

export default ReasonModal;
